// Unit preferences with localStorage persistence + conversions.
// Backend always stores metric (kg, cm). Frontend converts at the edges.

export const UNITS = {
  WEIGHT: "forged_unit_weight", // "kg" | "lb"
  HEIGHT: "forged_unit_height", // "cm" | "in"
};

export function getUnit(kind, fallback) {
  try {
    return localStorage.getItem(kind) || fallback;
  } catch {
    return fallback;
  }
}

export function setUnit(kind, value) {
  try {
    localStorage.setItem(kind, value);
  } catch {
    /* ignore */
  }
}

// --- weight ---
export const KG_PER_LB = 0.45359237;
export const LB_PER_KG = 2.20462262;

export const kgToLb = (kg) => kg * LB_PER_KG;
export const lbToKg = (lb) => lb * KG_PER_LB;

export function formatWeight(kg, unit) {
  if (kg == null) return "—";
  if (unit === "lb") return `${kgToLb(kg).toFixed(1)} lb`;
  return `${Number(kg).toFixed(1)} kg`;
}

// --- height ---
export const CM_PER_IN = 2.54;
export const IN_PER_CM = 1 / 2.54;

export const cmToIn = (cm) => cm * IN_PER_CM;
export const inToCm = (inches) => inches * CM_PER_IN;

// total inches -> {ft, in}
export function inchesToFtIn(totalIn) {
  const ft = Math.floor(totalIn / 12);
  const inches = Math.round((totalIn - ft * 12) * 10) / 10;
  return { ft, in: inches };
}
export const ftInToInches = (ft, inches) => Number(ft || 0) * 12 + Number(inches || 0);
